import { useDispatch } from 'react-redux'
import { ACTIONS, SAGA_ACTIONS } from '../../../_config'
import { ConfirmDialog, ShareDialog, SuccessExperimentDialog } from '../../../_config/types'
 
export function useDialog() {
    const dispach = useDispatch()
 
    const confirm = (data: ConfirmDialog) => {
        dispach({
            type: ACTIONS.DIALOG,
            payload: { ...data, dialog: 'confirm' },
        })
    }

    const share = (data: ShareDialog) => {
        dispach({
            type: ACTIONS.DIALOG,
            payload: { ...data, dialog: 'share' },
        })
    }
    
    const successExperiment = (data: SuccessExperimentDialog) => {
        dispach({
            type: ACTIONS.DIALOG,
            payload: { ...data, dialog: 'successExperiment' },
        })
    }
 
    const close = () => {
        dispach({ type: ACTIONS.DIALOG, payload: null })
    }
 
    return {
        confirm,
        share,
        close,
        successExperiment,
    }
}